module.exports = __webpack_public_path__ + "img/img2.f0363c29.svg";